export default {
  SET_USER_INFO: 'core/setUserInfo',
  SET_REGISTERED_CORPORATORS_INFO: 'core/setRegisteredCorporatorsInfo',
}
